import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";

// Assets
import carLogo from "../../../assets/images/my_digital_car.svg";

// Core Components
import MDCButton from "../../../components/core/MDCButton";
import MDCModal from "../../../components/core/MDCModal";

// Themes
import theme from "../../../themes/mdc-theme";

// Helpers
import { sanitizeHTML } from "../../../helpers/sanitizeHtml";

const useStyles = makeStyles({
  headerCss: {
    padding: "2rem",
    alignItems: "end",
  },
  headerColor: { color: theme.palette.MDCColors.black },
  contentCss: {
    fontFamily: theme.palette.typography.fontFamily,
    color: theme.palette.MDCColors.color15,
    padding: "0 2rem",
    wordBreak: "break-all",
    minHeight: "10rem",
    maxHeight: "20rem",
    overflow: "auto",
  },
  messageDescription: {
    "& a": {
      color: "#000000",
      textDecoration: "underline",
    },
  },
});

const MessageDetailsPopupDialog = (props) => {
  const { messageDetails } = props;

  const classes = useStyles();

  const getModalHeader = () => {
    return (
      <Grid container className={classes.headerCss}>
        <Grid item xs={6} className={classes.headerColor}>
          <h5>Nachrichtendetails</h5>
        </Grid>
        <Grid item xs={6} textAlign={"end"}>
          <img alt="My Digital Car" src={carLogo} width="92%" />
        </Grid>
      </Grid>
    );
  };

  const getModalBody = () => {
    return (
      <Grid container className={classes.contentCss}>
        <div
          className={classes.messageDescription}
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(messageDetails),
          }}
        />
      </Grid>
    );
  };

  const getModalFooter = () => {
    return (
      <Grid
        container
        pb={3}
        paddingX={"2rem"}
        justifyContent="flex-end"
        className={classes.footerCss}
      >
        <Grid item>
          <MDCButton
            onClick={() => props.handlePopupClose()}
            variant="outlined"
            label="Schließen"
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <MDCModal
        open={props.show}
        title={getModalHeader()}
        body={getModalBody()}
        footer={getModalFooter()}
        size="xs"
      />
    </>
  );
};

export default MessageDetailsPopupDialog;
